var React = require('react');

function FaceBookSvg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24C0.5 37.2548 11.2452 48 24.5 48Z","fill":"#02D2A0","key":0}),React.createElement("path",{"d":"M30.4768 12.1855V16.1493H28.12C27.2606 16.1493 26.6797 16.3302 26.3774 16.6921C26.0446 17.1642 25.8856 17.7371 25.9274 18.3133V21.1522H30.3268L29.7412 25.598H25.9274V37H21.3281V25.598H17.5V21.1522H21.3281V17.8776C21.3281 16.0136 21.8494 14.5685 22.8921 13.5425C23.9348 12.5164 25.3216 12.0034 27.0523 12.0034C28.1966 11.9844 29.3409 12.0452 30.4768 12.1855Z","fill":"#002432","key":1})]);
}

FaceBookSvg.defaultProps = {"width":"49","height":"48","viewBox":"0 0 49 48","fill":"none"};

module.exports = FaceBookSvg;

FaceBookSvg.default = FaceBookSvg;
